import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pencil, edit, write"} maskId="square-filled-radius-0-stroke-1-IconPencil"><path d="M17 1.79285L22.2071 6.99995L18.7071 10.4999L13.5 5.29284L17 1.79285Z" fill="currentColor"/><path d="M12.7929 6L2 16.7929V22H7.20711L18 11.2071L12.7929 6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPencil;
